/**
 * product-video-autoplay.js
 *
 * Makes Shopify-hosted MP4 product media behave like an animated product
 * image inside the product gallery:
 *   - plays automatically as soon as its gallery slide becomes active
 *   - loops continuously, muted, inline (no controls, no popup)
 *   - pauses when the customer swipes/clicks away from the slide
 *   - resumes automatically when the slide becomes active again
 *
 * Scoped only to ".productView-video.mp4 video" (the markup rendered for
 * media_type "video" in snippets/product-page.liquid), so YouTube/Vimeo
 * embeds (.productView-video.youtube / .vimeo) and any other video on the
 * site are untouched.
 */
(function () {
    function initInlineProductVideos(root) {
        var scope = root || document;

        scope.querySelectorAll('.productView-video.mp4 video').forEach(function (video) {
            if (video.dataset.inlineAutoplayBound) return;
            video.dataset.inlineAutoplayBound = 'true';

            // Belt-and-braces: enforce the required playback attributes in
            // case a merchant setting ever changes the underlying video_tag
            // output.
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.removeAttribute('controls');

            var slickSlide = video.closest('.slick-slide');

            function isActiveSlide() {
                // When there is no carousel wrapper (e.g. a product with a
                // single media item), the slide is always the active one.
                return slickSlide ? slickSlide.classList.contains('slick-current') : true;
            }

            function syncPlayback() {
                if (isActiveSlide()) {
                    var playPromise = video.play();
                    if (playPromise && typeof playPromise.catch === 'function') {
                        playPromise.catch(function () {
                            // Autoplay can be rejected in rare cases (e.g. low
                            // power mode). Nothing to do - the customer can
                            // still see the poster frame.
                        });
                    }
                } else if (!video.paused) {
                    video.pause();
                }
            }

            syncPlayback();

            if (slickSlide) {
                new MutationObserver(syncPlayback).observe(slickSlide, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initInlineProductVideos(document);
    });

    // Re-bind if the theme editor reloads the product section.
    document.addEventListener('shopify:section:load', function (event) {
        initInlineProductVideos(event.target);
    });
})();
